import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

//ru
import news_ru from "./locales/ru/news.json";
import login_ru from "./locales/ru/login.json";
import history_ru from "./locales/ru/history.json";
import auth_ru from "./locales/ru/auth.json";
import exchange_ru from "./locales/ru/exchange.json";
import exchanger_error_ru from "./locales/ru/exchange_error.json";
import profile_ru from "./locales/ru/profile.json";
import validate_ru from "./locales/ru/validate.json";

//uz
import news_uz from "./locales/uz/news.json";
import login_uz from "./locales/uz/login.json";
import history_uz from "./locales/uz/history.json";
import auth_uz from "./locales/uz/auth.json";
import exchange_uz from "./locales/uz/exchange.json";
import exchanger_error_uz from "./locales/uz/exchange_error.json";
import profile_uz from "./locales/uz/profile.json";
import validate_uz from "./locales/uz/validate.json";


//ru
import news_en from "./locales/en/news.json";
import login_en from "./locales/en/login.json";
import history_en from "./locales/en/history.json";
import auth_en from "./locales/en/auth.json";
import exchange_en from "./locales/en/exchange.json";
import exchanger_error_en from "./locales/en/exchange_error.json";
import profile_en from "./locales/en/profile.json";
import validate_en from "./locales/en/validate.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        news : news_ru,
        history : history_ru,
        login: login_ru,
        auth: auth_ru,
        exchange: exchange_ru,
        exchange_error: exchanger_error_ru,
        profile: profile_ru,
        validate : validate_ru,
      },
      uz: {
        news : news_uz,
        history : history_uz,
        login: login_uz,
        auth: auth_uz,
        exchange: exchange_uz,
        exchange_error: exchanger_error_uz,
        profile: profile_uz,
        validate : validate_uz,
      },
      en:{
        news : news_en,
        history : history_en,
        login : login_en,
        auth : auth_en,
        exchange : exchange_en,
        exchanger_error : exchanger_error_en,
        profile : profile_en,
        validate : validate_en,
      }
    },
    fallbackLng: "ru",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    ns: ["news", "history", "login", "exchange", "exchanger_error", "profile", "validate"],
    defaultNS: "login",
  });

export default i18n;
